import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Avatar } from 'avatar-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MemberItem = ({
  user
}) => {
  const displayName = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  const textContent = displayName || user.email;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    paddingBlock: "100",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexShrink: "0",
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Avatar, {
        size: "xs",
        hubSpotUserEmail: user.email,
        displayName: displayName
      })
    }), /*#__PURE__*/_jsx(Box, {
      maxInlineSize: "220px",
      children: /*#__PURE__*/_jsx(TruncateString, {
        children: textContent
      })
    })]
  });
};